import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithDecryption } from "../baseQueryWithEncryption";

export const CompanyMgmt = createApi({
  reducerPath: "CompanyMgmt",
  baseQuery: baseQueryWithDecryption(import.meta.env.VITE_COMPANY_API_URL),
  tagTypes: ["company-mgmt", "BugDetail"],
  endpoints: (builder) => ({
    //Company
    getCompany: builder.query({
      query: () => "company",
      providesTags: ["company-mgmt"],
    }),
    getCompanyDetails: builder.query({
      query: () => `companyMgmt-details`,
      providesTags: ["company-mgmt"],
    }),

    updateCompany: builder.mutation({
      query: (data) => ({
        url: `company`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["company-mgmt"],
    }),

    deleteCompany: builder.mutation({
      query: () => ({
        url: `company`,
        method: "DELETE",
      }),
      invalidatesTags: ["company-mgmt"],
    }),

    getAttachmentUrl: builder.mutation({
      query: (body) => ({
        url: `/url`,
        body: body,
        method: "POST",
      }),
    }),
    getProjectOrReposForImport: builder.query({
      query: (from) => ({
        url: "gateway/projects",
        method: "GET",
        params: { from },
      }),
    }),
    getRepoBranches: builder.mutation({
      query: ({ repoName, from }) => ({
        url: `/repo-branches?from=${from}`,
        method: "POST",
        body: { repoName },
      }),
    }),
    raisePR: builder.mutation({
      query: (payload) => ({
        url: "/branch-commit-pr?from=GIT_HUB",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["BugDetail"],
    }),
  }),
});

export const {
  //Company
  useGetCompanyQuery,
  useGetCompanyDetailsQuery,
  useUpdateCompanyMutation,
  useDeleteCompanyMutation,
  useGetAttachmentUrlMutation,
  useGetProjectOrReposForImportQuery,
  useGetRepoBranchesMutation,
  useRaisePRMutation,
} = CompanyMgmt;
